import { ReactNode, createContext, useState } from "react";

type AttendanceIdContextType = {
	attendanceId: number;
	setAttendanceId: (attendanceId: number) => void;
};

type AttendanceIdContextProviderProps = {
	children: ReactNode;
};

export const AttendanceIdContext = createContext({} as AttendanceIdContextType);

export function AttendanceIdContextProvider({ children }: AttendanceIdContextProviderProps) {
	const [attendanceId, setAttendanceId] = useState(0);

	return (
		<AttendanceIdContext.Provider value={{ attendanceId, setAttendanceId }}>
			{children}
		</AttendanceIdContext.Provider>
	);
}
